import { Badge, BlockStack, Text } from '@shopify/polaris';
import apiClient from '../utils/api';
import { refundStatusDisplay } from '../utils/refund-status';

/**
 * An order's refunds in one table cell: how much the retailer refunded, on how many refunds,
 * and where 2W is with them - so a refunded order is visible in a list without opening it.
 *
 * `refunds` is the server's per-order totals ({ count, total, unreadable, currencyCode,
 * status }). No refunds, or none read, shows a dash: an order without refunds is the ordinary
 * case and a badge on every row would bury the ones that have them.
 *
 * `unreadable` refunds are named rather than folded into the total, because a total that
 * silently leaves a refund out reads as the whole of it.
 */
export default function RefundsCell({ refunds }) {
  if (!refunds || !refunds.count) return <Text variant="bodySm" tone="subdued">—</Text>;
  const { label, tone } = refundStatusDisplay(refunds.status);
  return (
    <BlockStack gap="050" inlineAlign="start">
      <Text variant="bodySm" numeric>
        {`-${apiClient.formatCurrency(Math.abs(refunds.total ?? 0), refunds.currencyCode || undefined)}`}
      </Text>
      <Text variant="bodySm" tone="subdued">
        {`${refunds.count} refund${refunds.count === 1 ? '' : 's'}`}
        {refunds.unreadable ? ` (${refunds.unreadable} without a readable amount)` : ''}
      </Text>
      <Badge tone={tone}>{label}</Badge>
    </BlockStack>
  );
}
